export default __webpack_public_path__ + "static/media/sweet-strawberry.91165105.png";